<template>
  <div class="login-wrapper">
    <v-form id="reset-form" @submit.prevent="resetClient" class="login px-5 py-3">
      <img class="logo d-none d-md-block mx-auto my-3" src="/img/veroFresh.png">
      <div v-html="$t('client_reset_blurb')"></div>
      <v-btn type="submit" class="w-100 mx-auto mt-4 mb-2" color="primary">
        <v-icon>mdi-recycle</v-icon>
        <span class="ml-1" v-html="$t('reset_verofresh')"></span>
      </v-btn>
    </v-form>
  </div>
</template>

<script>

export default {
  name: 'ResetClient',
  data() {
    return {
      sending: false
    }
  },
  methods: {
    resetClient() {
      this.sending = true
      const veroFreshApp = localStorage.getItem('veroFreshApp')
      localStorage.removeItem('veroFreshApp')
      setTimeout(function () {
        window.location.href = '/'
      }, 5000)
      // Log localStorage contents to server via retrace-vue-stack
      throw (new Error('User reset client state: ' + veroFreshApp))
    }
  }
}
</script>

<style scoped>

</style>
